import { useQuery } from "react-query";
import { getJobStat } from "services/job.service";

export default function useJobStats() {
  return useQuery("job-stats", async () => await getJobStat());
}
